import PropTypes from "prop-types";

import getLanguageMetaData from "@/components/languages/get-language-meta-data";

const isObject = (o) => {
  return o && typeof o === "object" && !Array.isArray(o);
};

function getNextLanguageLink({
  currentLanguage = "default",
  languageLinks = {},
}) {
  const languageLinksEntries =
    (isObject(languageLinks) &&
      Object.entries(languageLinks).sort(([a], [b]) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        // a must be equal to b
        return 0;
      })) ||
    [];

  if (!languageLinksEntries?.length) {
    return null;
  }

  const currentIndex = languageLinksEntries.indexOf(
    languageLinksEntries.find(([locale]) => locale === currentLanguage)
  );

  const [locale, url] =
    [
      ...languageLinksEntries.slice(currentIndex + 1),
      ...languageLinksEntries.slice(0, currentIndex + 1),
    ].shift() || [];

  return Object.assign({ locale, url }, getLanguageMetaData(locale));
}

getNextLanguageLink.propTypes = {
  currentLanguage: PropTypes.string,
  languageLinks: PropTypes.object,
};

export default getNextLanguageLink;
